import { PROMO_PACKAGES } from '@/lib/agencies'

interface EcommerceItem {
  item_id: string
  item_name: string
  price: number
  quantity: number
  item_type?: string
}

interface EcommercePayload {
  meta_event_id?: string
  value: number
  currency: string
  items: EcommerceItem[]
  transaction_id?: string
}

export function pushEcommerceEvent(event: string, ecommerce: EcommercePayload) {
  // Promo / free packages should not pollute ecommerce conversion tracking
  if (ecommerce.items.some(item => PROMO_PACKAGES.includes(item.item_id))) {
    return
  }

  const isDevelopment = process.env.BACKEND_IS_PRODUCTION !== 'true'
  const payload = { event, ecommerce }

  if (isDevelopment) {
    console.log('window.dataLayer.push({ ecommerce: null })')
    console.log(`window.dataLayer.push({ payload: ${JSON.stringify(payload, null, 2)} })`)
    return
  }

  window.dataLayer = window?.dataLayer || []
  window.dataLayer.push({ ecommerce: null })
  window.dataLayer.push(payload)
}

/**
 * Općeniti GTM događaj (npr. praćenje stranica za agencije).
 * U developmentu samo ispisuje payload u konzolu, u produkciji ga šalje u dataLayer.
 */
export function pushEvent(event: string, data: Record<string, unknown> = {}) {
  const isDevelopment = process.env.BACKEND_IS_PRODUCTION !== 'true'
  const payload = { event, ...data }

  if (isDevelopment) {
    console.log(`window.dataLayer.push({ payload: ${JSON.stringify(payload, null, 2)} })`)
    return
  }

  window.dataLayer = window?.dataLayer || []
  window.dataLayer.push(payload)
}
